import type { TestGroupingFeedbackSchemaType } from '@vedalib/editor/lib/brand'
import { useContext } from 'use-context-selector'

import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import type { ElementFeedbackCss } from 'services/Branding/types'

import TestGroupingContext from '../../TestGroupingContext'
import { FeedbackIconStyled } from '../../styled/TestGroupingStyled'

interface IFeedbackIconProps {
  isTrueAnswer: boolean
  feedback: ElementFeedbackCss<TestGroupingFeedbackSchemaType>
}

const FeedbackIcon: React.FC<IFeedbackIconProps> = ({ isTrueAnswer, feedback }) => {
  const { styles } = useContext(TestGroupingContext)
  const hasCustomImage = isTrueAnswer
    ? !!feedback?.correct?.backgroundImage
    : !!feedback?.incorrect?.backgroundImage

  const iconColor = isTrueAnswer ? feedback?.correct?.color : feedback?.incorrect?.color

  return (
    <FeedbackIconStyled $feedback={feedback} $isCorrect={isTrueAnswer} $styles={styles}>
      {!hasCustomImage && (
        <Icon color={iconColor} name={isTrueAnswer ? 'success' : 'error'} size={KitSize.S} />
      )}
    </FeedbackIconStyled>
  )
}

export default FeedbackIcon
